/// <amd-module name="Search/Shared/Base/Sources/OrgInfoDataProviderSource" />

import { IOrganizationInfo } from "Search/Shared/Base/Stores/OrganizationInfoStore";
import { IVssContributionService } from "VSS/Platform/Contribution";
import { IVssPageContext } from "VSS/Platform/Context";
import { IVssPerformanceService } from "VSS/Platform/Performance";
import { SEARCH_AREA } from "Search/Shared/CustomerIntelligenceConstants";

export class OrgInfoDataProviderSource {

    public static DATA_PROVIDER_ID = "ms.vss-search-platform.organization-info-data-provider";
    public static PERF_SCENARIO_NAME = "GetOrganizationInfoFetchTime";

    private _contributionService: IVssContributionService;
    private _pageContext: IVssPageContext;

    constructor(pageContext: IVssPageContext) {
        this._pageContext = pageContext;
        this._contributionService = pageContext.getService<IVssContributionService>("IVssContributionService");
    }

    public getOrganizationInfo(): Promise<IOrganizationInfo> {
        const performanceService = this._pageContext.getService<IVssPerformanceService>("IVssPerformanceService");
        performanceService.startScenario(OrgInfoDataProviderSource.PERF_SCENARIO_NAME, false);

        return this._contributionService.getDataAsync<IOrganizationInfo>(OrgInfoDataProviderSource.DATA_PROVIDER_ID)
            .then((organizationInfo: IOrganizationInfo) => {
                performanceService.endScenario(SEARCH_AREA, OrgInfoDataProviderSource.PERF_SCENARIO_NAME, false);
                return organizationInfo;
            }, (error: Error) => {
                performanceService.endScenario(SEARCH_AREA, OrgInfoDataProviderSource.PERF_SCENARIO_NAME, false);
                throw error;
            });
    }
}
